module.exports = __webpack_public_path__ + "media/images/logo.dark-29f8641f32f26fbf3234ed3de761b462.png";